// extracted by mini-css-extract-plugin
export default {"root":"styles_root__18h0b","bookingAssistance":"styles_bookingAssistance__25IYs","bookingAssistanceTitle":"styles_bookingAssistanceTitle__6FrlF"};